<template lang="pug">
    div.floating-hotline(:class="classFloating")
        div.f-header-tools
            button(@mouseenter="updateHeight" @click="toggleShown" v-html="labelButton")

        div.wrap-body(:class="is_shown ? '': 'in-active'" ref="wrapBody")
            div(ref="wrapBodyEntry")
                .f-header
                    div.image
                        img(:src="logo" alt="Liên hệ")
                .f-tab
                    ul
                        li(v-for="t in types")
                            a(href="javascript:"
                                :class="tabCurrent == t.name ? 'active' : '' "
                                @click="show(t.name)") {{ t.display }}

                .f-body
                    ul
                        li(v-for="(item) in phones")
                            a.item-contact(:href="item.href" target="_blank" ref="nofollow")
                                img.icon(:class="'icon-' + tabCurrent" :src="iconCurrent")
                                span.name.display {{ item.name }}
                                span.phone {{ item.phone_display }}

                    div.footer-action(v-if="footer_complaint")
                        div
                            b Than phiền góp ý
                        div.footer-link
                            a(:href="'tel:' + footer_phone"  class="")
                                span {{ footer_phone }}
</template>

<style lang="less">
.floating-hotline {
    position: relative;
    z-index: 999;
    .footer-action {
        padding: 7px;
        text-align: center;
        border-top: 1px solid #f4f4f4;
        margin-top: 5px;
        font-size: 12px;
    }
    .footer-link {
        margin-top: 5px;
        a{
            display: block;
        }
    }
    .f-header-tools {
        position: absolute;
        bottom: 100%;
        background-color: var(--bg-header-tools, orange);
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        right: 10px;

        button {
            transition: all 0.15s;
            background-color: transparent;
            border: none;
            font-size: 11px;
            padding: 3px 10px 5px;
            white-space: nowrap;
            box-shadow: none;
            outline: none;
            cursor: pointer;
        }
    }

    &.in-active {
        .f-header-tools {
            button {
                font-size: 16px;
            }
        }
    }

    &.br {
        position: fixed;
        bottom: 10px;
        right: 10px;
    }

    .wrap-body {
        height: 100%;
        overflow: hidden;
        margin: auto;
        width: var(--floating-width, 280px);
        font-size: 14px;
        transition: all 0.15s;
        opacity: 1;
        visibility: visible;
        > div {
            border: var(--floating-border, 3px solid orange);
            width: var(--floating-width, 280px);
            background-color: var(--floating-bg, #f1f1f1);
            border-radius: 10px;
            overflow: hidden;
            @media(max-width: 991px) {
                width: 100%;
            }
        }
        &.in-active {
            height: 0 !important;
            width: 0;
            border-width: 0;
            opacity: 0;
        }
    }

    ul {
        margin: auto;

        li {
            list-style: none;
        }
    }

    .f-header {
        padding-bottom: 5px;
        margin-bottom: 5px;
        text-align: center;

        img {
            max-width: 100%;
            max-height: 50px;
            object-fit: contain;
        }
    }

    .f-tab {
        ul {
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            padding: 0;
            list-style: none;

            li {
                a {
                    display: block;
                    padding: 4px 10px;
                    color: #333;
                    text-decoration: none;
                    min-width: 80px;
                    text-align: center;

                    &.active {
                        color: #03a9f4;
                        font-weight: bold;
                        background-color: #ffffff;
                        border-radius: 0;
                        border-top-left-radius: 5px;
                        border-top-right-radius: 5px;
                    }
                }

                + li {
                    a {

                    }
                }
            }
        }
    }

    .f-body {
        padding-top: 5px;
        background: #ffffff;
        ul {
            padding: 0;
            display: flex;
            flex-wrap: wrap;
        }

        li {
            list-style: none;
            min-width: 50%;
            max-width: 50%;
        }

        a.item-contact {
            display: block;
            line-height: 16px;
            white-space: nowrap;
            font-size: 12px;
            position: relative;
            padding: 8px 3px 8px 33px;

            &:hover {
                background-color: #f0f0f0;
            }

            .name {
                display: block;
                font-weight: 600;
                color: #333;
            }

            .phone {
                color: red;
                font-weight: bold;
            }

            .icon {
                width: 22px;
                height: 22px;
                display: block;
                position: absolute;
                top: 10px;
                left: 5px;
                margin: auto;
                background-position: center;
                background-repeat: no-repeat;
                border-radius: 50%;
            }
        }
    }

    @media(max-width: 991px){
        left: 0;
        width: 80%;
        margin: auto;
        right: 0 !important;
        bottom: 100px !important;

        .f-header-tools {
            z-index: 9;
            text-align: center;
            background: none;
            position: fixed;
            top: 50%;
            left: auto;
            right: 0;
            bottom: auto;
            margin: auto;
            button {
                font-size: 16px;
                background-color: var(--bg-header-tools, orange);
                border-radius: 15px 0 0 15px;
                i {
                    display: block;
                    width: 30px;
                    height: 30px;
                    line-height: 20px;
                    font-size: 14px;
                    text-align: center;
                    background-color: #fff;
                    padding: 5px;
                    border-radius: 50%;
                    margin: auto;
                    margin-bottom: 4px;
                    color: #000;
                }
            }
        }

        .wrap-body {
            width: 100% !important;
            height: auto !important;
        }
    }
}
</style>

<script>
export default {
    methods: {
        show(type) {
            this.tabCurrent = type;
        },

        toggleShown() {
            this.is_shown = !this.is_shown;
        },

        updateHeight() {
            this.$refs.wrapBody.style.height = `${this.$refs.wrapBodyEntry.scrollHeight + 6}px`;
        }
    },
    mounted() {
        if (window.innerWidth <= 991)
            this.is_shown = false;
    },
    watch:{
        tabCurrent() {
            setTimeout(() => {
                this.updateHeight();
            }, 50)
        }
    },
    computed: {
        phones() {
            return this.hotline[this.tabCurrent] ? this.hotline[this.tabCurrent] : []
        },

        iconCurrent() {
            var selected = this.types.find((i) => {
                return i.name == this.tabCurrent
            });

            return selected.icon ? selected.icon : '';
        },


        classFloating() {
            var css = this.position;
            css += ` ${this.is_shown ? '' : 'in-active'}`;

            return css;
        },

        labelButton() {
            if (window.innerWidth < 991) {
                return  this.is_shown ? '<i class="fa fa-times"></i> Đóng' : '<i class="fa fa-phone"></i> Gọi';
            } else{
                return  this.is_shown ? 'Đóng lại' : 'Liên hệ';
            }
        }
    },
    data() {
        return {
            tabCurrent: 'phone',
            is_shown: true,
        }
    },
    props: {
        position: {
            type: String,
            default: 'br'
        },
        footer_complaint:{
            type: Boolean,
            default: false
        },
        footer_email:{
            type: String,
            default: ""
        },
        footer_phone:{
            type: String,
            default: ""
        },
        logo: {
            type: String,
            default: "https://inkythuatso.com/themes/inkythuatso/imgs/logo_inkythuatso.svg"
        },
        types: {
            type: Array,
            default() {
                return [{
                    name: 'phone',
                    display: "Gọi điện",
                    icon: "/asset/phone.png"
                }, {
                    name: 'zalo',
                    display: "Zalo",
                    icon: "/asset/zalo.png"
                }]
            }
        },
        hotline: {
            type: Object,
            default() {
                return {
                    phone: [
                        {
                            name: "Ms.Trinh",
                            phone_display: "(028) 224 66666",
                            href: "tel:02822466666"
                        },
                        {
                            name: "Ms.Trinh",
                            phone_display: "(028) 224 66666",
                            href: "tel:02822466666"
                        },
                        {
                            name: "Ms.Trinh",
                            phone_display: "(028) 224 66666",
                            href: "tel:02822466666"
                        },
                        {
                            name: "Ms.Trinh",
                            phone_display: "(028) 224 66666",
                            href: "tel:02822466666"
                        }
                    ],
                    zalo: [
                        {
                            name: "Ms.Hồng",
                            phone_display: "(028) 224 66666",
                            href: "https://zalo.me/02822466666"
                        }
                    ]
                }
            }
        }
    },
    name: "MBNFloatingHotline",
}
</script>